export default "__VITE_ASSET__55d39ec7__"